import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { Voucher } from 'src/app/interfaces/voucher';
import { LanguageService } from 'src/app/services/general/language.service';
import { BlastPackageService } from 'src/app/services/blast/blast-package.service';
import { VoucherService } from 'src/app/services/subscription/voucher.service';
import { BlastCreditRedeemComponent } from 'src/app/components/blast/credit/blast-credit-redeem/blast-credit-redeem.component';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss'],
})
export class PromoComponent implements OnInit, OnDestroy {

  redeemMode: boolean;

  voucher: Voucher;

  voucherId: string;

  language: string;

  constructor(
    private router: Router,
    private modalController: ModalController,
    private blastPackageService: BlastPackageService,
    private languageService: LanguageService,
    private voucherService: VoucherService,
  ) { }

  ngOnInit() {}

  ngOnDestroy() {
    
  }

  ionViewWillEnter() {
    this.language = this.getLanguage();
    if (!this.redeemMode && !this.voucher?.voucherId) {
      if (!this.voucherId) {
        this.voucherId = this.voucherService.getSpecialPromoVoucher();
      }
      this.voucher = this.voucherService.getSpecialPromoVoucherById(this.voucherId);
    }
  }


  /**
   * Dismiss modal
   */
  async dismissModal() {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { await modal.dismiss(); }
    }
  }

  async presentBlastCreditRedeemModal() {
    const modal = await this.modalController.create({
      component: BlastCreditRedeemComponent,
      cssClass: 'modal-full-screen-bk',
      componentProps: {
      }
    });
    modal.present();
  }

  getBlastPriceByCredit(blastCredit: number) {
    const price = this.blastPackageService.calculateBlastPackagePrice(blastCredit);
    return price;
  }

  getLanguage() {
    let language = this.languageService.getUserLanguage()?.code?.toLowerCase();

    return language && language !== 'ms' ? language : 'en';
  }


  getSpecialPromo(revertStartDays?: number) {
    let voucherId = this.voucherService.getSpecialPromoVoucher(new Date());
    if (!voucherId && revertStartDays) {
      voucherId = this.voucherService.getSpecialPromoVoucher(new Date(), revertStartDays);
    }
    return voucherId;
  }

  getSpecialVoucherById(voucherId: string) {
    return this.voucherService.getSpecialPromoVoucherById(voucherId);
  }


  async select() {
    if (this.redeemMode) {
      await this.dismissModal();
      await this.presentBlastCreditRedeemModal();
    } else {
      await this.goPremiumPage();
      await this.dismissModal();
    }
    
  }

  async goPremiumPage() {
    const navigationExtras: NavigationExtras = {
      state: {  }
    };
    await this.router.navigate([ '/subscription/premium' ], navigationExtras);
  }

}
